import { createContext, useReducer } from "react";
import { companyReducer } from "./Company.reducer";
import { select_company } from "./Company.type";


export const CompanyContext = createContext();

const initCompany = {
  name: "",
};
export const CompanyContextProvider = ({ children }) => {
  const [company, dispatch] = useReducer(companyReducer, initCompany);
  const companySelector = (payload) => {
    dispatch({ type: select_company, payload });
  };
  return (
    <CompanyContext.Provider value={{ company, companySelector }}>
      {children}
    </CompanyContext.Provider>
  );
};
